import React, {ComponentProps} from 'react'
import {UseFormReturn} from 'react-hook-form'
import {usePromoCodeFields} from '../../../hooks/forms/usePromoCodeFields'
import {Box, Button, Flex, Stack, Text} from '../../../vanilla'
import {Field} from '../../field'
import {MIN_PROMO_CODE_LENGTH} from '../../../utils/constants'

interface PromoCodeFieldsProps extends ComponentProps<typeof Box> {
  form: UseFormReturn<{code: string}>
}

export const PromoCodeFields = ({form, ...props}: PromoCodeFieldsProps) => {
  const fields = usePromoCodeFields({form})

  const code: string = form.watch('code')

  return (
    <Flex {...props}>
      <Stack spacing="4px" align="flex-start" flexGrow="1">
        <Text variant="text3" as="label">
          Promo Code
        </Text>
        <Field
          inputGroupProps={{display: 'flex', width: ['full', 'two-thirds']}}
          inputProps={{flex: '1', marginRight: '8px'}}
          label=""
          {...fields.code}
        />
      </Stack>
      <Button
        marginLeft="8px"
        type="submit"
        alignSelf="flex-start"
        marginTop="28px"
        size="sm"
        disabled={form.formState.isSubmitting || code?.length < MIN_PROMO_CODE_LENGTH}
        variant="secondary"
      >
        Apply code
      </Button>
    </Flex>
  )
}
